// const CITY_LAYERS = 'https://www.medellin.gov.co/arcgis/rest/services/ServiciosCiudad/CartografiaBase_WEBM/MapServer/export?bbox='
const CITY_LAYERS = 'https://www.medellin.gov.co/mapas/rest/services/ServiciosPlaneacion/POT48_Base/MapServer/export?dpi=96&bbox='

const AUTH_URL = process.env.AUTH_URL

const API_URL = process.env.API_URL

const VEHICLES_URL = `${API_URL}/avl/vehicles`
const VEHICLES_CURRENT = `${VEHICLES_URL}/current`
const VEHICLES_TYPE = `${VEHICLES_URL}/types`
const LAST_POSITIONS_URL = `${API_URL}/avl/positions/last`

const MISSIONS_URL = `${API_URL}/avl/missions`
const MISSIONS_ALARMS = `${API_URL}/avl/missions/failed`
const MISSIONS_TEMPLATES = `${API_URL}/avl/missions/base/tree`
const MISSIONS_SERVICES = `${API_URL}/avl/missions/services`
const GEO_ACTIVE_MISSION = `${API_URL}/avl/missions/geo-active-mission`
const MISSIONS_BASE = `${API_URL}/avl/missions/base`

const ALERTS_URL = `${API_URL}/avl/alerts`
const GENERAL_JUSTIFICATION_ALARM = `${API_URL}/avl/justifications`
const JUSTIFICATION_ALARM = `${API_URL}/avl/missions/alarms`
const SPEED_ALARMS = `${API_URL}/avl/speed-alerts`
const MOVEMENT_ALARMS = `${API_URL}/avl/movement-alarms`
const UNREPORTED_EVENTS_ALARMS = `${API_URL}/avl/unreported-event-alarms`
const PARKING_ALARMS = `${API_URL}/avl/parking-alarms`
const GEOFENCE_IN_ALARMS = `${API_URL}/avl/missions/inside`
const VEHICLES_WITHOUT_EVENTS_3H_ALARMS = `${API_URL}/avl/device-vehicle-no-events-alarms`

const GEO_URL = `${API_URL}/geo`
const GEOFENCES_URL = `${GEO_URL}/areas/fences`
const FENCES = `${API_URL}/avl/fences`
const FENCES_FROM_GEO = `${API_URL}/avl/fences/from-geo`

const AGENCIES = `${API_URL}/avl/agencies`
const AGENCIES_TREE = `${API_URL}/avl/agencies/tree`

const POINT_DATA = `${VEHICLES_URL}/around`
const POINT_REPORT = `${VEHICLES_URL}/around/report`
const TIME_REPORT = VEHICLES_URL
const SPEED_TIME_REPORT = `${API_URL}/avl/speed-alerts/report`
const LAST_EVENT_REPORT = `${API_URL}/avl/last-positions/report`
const CURRENT_CONDITION_REPORT = `${API_URL}/avl/vehicles/statuses/report`
const MISSION_FAIL_REPORT_TIME = `${API_URL}/avl/missions/failed/report`
const MOVEMENT_ALARMS_REPORT_TIME = `${API_URL}/avl/movement-alarms/report`
const PARKING_ALARM_REPORT_TIME = `${API_URL}/avl/parking-alarms/report`
const GEOFENCE_IN_ALARM_REPORT_VEHICLE = `${API_URL}/avl/vehicles`
const GEOFENCE_IN_ALARM_REPORT_TIME = `${API_URL}/avl/missions/inside/report`

const VALID_STATUSES = `${VEHICLES_URL}/valid-statuses`
const DEFAULT_REASONS = `${VEHICLES_URL}/default-reasons`
const CURRENT_DATE_TIME_CO = `${API_URL}/current-datetime`

const IN_MISSION = `${API_URL}/avl/vehicles/in-mission`
const VEHICLES_IN_A_MISSION = `${API_URL}/avl/vehicles/by-mission-id`

const LOGS_HISTORY = `${API_URL}/avl/logs/history`
const LOGS_HISTORY_REPORT = `${API_URL}/avl/logs/history/report`

const STATIC_HEATMAP = `${API_URL}/avl/analytics/maps/heatmaps/static/vehicles`
const DYNAMIC_HEATMAP = `${API_URL}/avl/analytics/maps/heatmaps/dynamic/vehicles`

export {
  MOVEMENT_ALARMS_REPORT_TIME,
  MISSION_FAIL_REPORT_TIME,
  VEHICLES_IN_A_MISSION,
  CURRENT_DATE_TIME_CO,
  CURRENT_CONDITION_REPORT,
  LAST_EVENT_REPORT,
  IN_MISSION,
  UNREPORTED_EVENTS_ALARMS,
  FENCES_FROM_GEO,
  FENCES,
  MISSIONS_SERVICES,
  MOVEMENT_ALARMS,
  GENERAL_JUSTIFICATION_ALARM,
  JUSTIFICATION_ALARM,
  POINT_DATA,
  MISSIONS_TEMPLATES,
  VALID_STATUSES,
  DEFAULT_REASONS,
  SPEED_TIME_REPORT,
  MISSIONS_ALARMS,
  CITY_LAYERS,
  SPEED_ALARMS,
  TIME_REPORT,
  POINT_REPORT,
  VEHICLES_TYPE,
  AGENCIES_TREE,
  LAST_POSITIONS_URL,
  API_URL,
  VEHICLES_URL,
  VEHICLES_CURRENT,
  GEO_URL,
  GEOFENCES_URL,
  MISSIONS_URL,
  AUTH_URL,
  ALERTS_URL,
  AGENCIES,
  GEO_ACTIVE_MISSION,
  PARKING_ALARMS,
  GEOFENCE_IN_ALARMS,
  PARKING_ALARM_REPORT_TIME,
  VEHICLES_WITHOUT_EVENTS_3H_ALARMS,
  MISSIONS_BASE,
  LOGS_HISTORY,
  LOGS_HISTORY_REPORT,
  GEOFENCE_IN_ALARM_REPORT_VEHICLE,
  GEOFENCE_IN_ALARM_REPORT_TIME,
  STATIC_HEATMAP,
  DYNAMIC_HEATMAP
}



// WEBPACK FOOTER //
// ./src/utils/endpoints.js